import React from 'react';
import EmployeeSalaryDetailPage from '../../payroll/EmployeeSalaryDetailPage';

const WholesaleEmployeeSalaryDetailPage = () => {
  return <EmployeeSalaryDetailPage isWholesale={true} />;
};

export default WholesaleEmployeeSalaryDetailPage;
